import { j as b } from "../../../node_modules/react/jsx-runtime.js";
import { memo as g } from "react";
import e from "./Flex.module.scss.js";
import { clsx as k } from "../../../node_modules/clsx/dist/clsx.m.js";
const q = ({
  children: t,
  justifyBetween: s,
  flexRow: n,
  flexRowReverse: r,
  flexCol: o,
  flexColReverse: f,
  flexNoWrap: i,
  flexWrapReverse: m,
  flexWrap: l,
  justifyStart: u,
  justifyEnd: x,
  justifyCenter: a,
  justifyAround: j,
  justifyEvenly: y,
  justifyItemsStart: c,
  justifyItemsEnd: p,
  justifyItemsCenter: d,
  justifyItemsStretch: E,
  contentCenter: v,
  contentStart: C,
  contentEnd: R,
  contentBetween: S,
  contentAround: w,
  contentEvenly: I,
  itemsStart: B,
  itemsEnd: W,
  itemsCenter: h,
  itemsBaseline: A,
  itemsStretch: F,
  className: N,
  ...$
}) => /* @__PURE__ */ b.jsx(
  "div",
  {
    className: k(
      e.flex,
      // direction
      n && e.flexRow,
      r && e.flexRowReverse,
      o && e.flexCol,
      f && e.flexColReverse,
      // wrap
      i && e.flexNoWrap,
      m && e.flexWrapReverse,
      l && e.flexWrap,
      // justify-content
      u && e.justifyStart,
      x && e.justifyEnd,
      a && e.justifyCenter,
      s && e.justifyBetween,
      j && e.justifyAround,
      y && e.justifyEvenly,
      // justify-items
      c && e.justifyItemsStart,
      p && e.justifyItemsEnd,
      d && e.justifyItemsCenter,
      E && e.justifyItemsStretch,
      // align-content
      v && e.contentCenter,
      C && e.contentStart,
      R && e.contentEnd,
      S && e.contentBetween,
      w && e.contentAround,
      I && e.contentEvenly,
      // align-items
      B && e.itemsStart,
      W && e.itemsEnd,
      h && e.itemsCenter,
      A && e.itemsBaseline,
      F && e.itemsStretch,
      // other
      N
    ),
    ...$,
    children: t
  }
), J = g(q);
export {
  J as default
};
//# sourceMappingURL=Flex.js.map
